export default __webpack_public_path__ + "static/media/sliderContinuous_noThemeSelected.a387be6c.svg";